<template>
    <button class="px-15 py-10 rounded bg-orange text-white font-semibold">
        <slot></slot>
    </button>
</template>